import React from "react";
import DonutChart from "common-ui-components/components/donut-chart/DonutChart";
import InfoBox from "common-ui-components/components/info-box/InfoBox";
const SeverityBreakdown = ({ overview, loading = false }) => {
  const value = (count) => loading || count == null ? 0 : Number(count);
  const severity = [
    {
      id: "Critical",
      label: "Critical",
      value: value(overview?.totalCriticalVulnerabilities),
      color: "#d92d20",
    },
    {
      id: "High",
      label: "High",
      value: value(overview?.totalHighVulnerabilities),
      color: "#f79009",
    },
    {
      id: "Medium",
      label: "Medium",
      value: value(overview?.totalMediumVulnerabilities),
      color: "#2e6be6",
    },
    {
      id: "Low",
      label: "Low",
      value: value(overview?.totalLowVulnerabilities),
      color: "#8792a2",
    },
    {
      id: "Unrated",
      label: "Unrated",
      value: value(overview?.totalUnratedVulnerabilities),
      color: "#8b5cf6",
    },
  ];
  const total = value(overview?.totalVulnerabilities);
  return (
    <div style={{ width: "100%" }}>
      <InfoBox
        header="Severity Breakdown"
        subtitle="Open vulnerabilities by severity"
        badge={`${total.toLocaleString()} total open`}
        badgeProps={{ style: { background: "#fdf0d5", color: "#92400e" } }}
        headerProps={{ style: { color: "#111111", borderRadius: "16px" } }}
        style={{ width: "100%", minWidth: 0 }}
      >
        <DonutChart
          data={severity}
          size="15rem"
          thickness={0.2}
          barLegend
          centerText={total}
          centerSubText="total open"
          gap="2rem"
          //   onDatumClick={(d) => console.log(d.id)}
        />
      </InfoBox>
    </div>
  );
};

export default SeverityBreakdown;
